<template>
  <div>
    <vertical>
      <page-header
        :items="headerItems"
        :title="`لیست واریزی ها و برداشت های کیف پول ${userInformation.walletType === 'TOMAN' ? 'تومانی' : 'دادکوینی'} / ${userInformation.userName}`"
      />
      <div class="card p-3">
        <table-header notDropdown searchVisible :filterList="userInformation.walletType === 'DADCOIN' ? filterList.slice(0, 2) : filterList" @tableObj="onSearchQuery" />
        <Table :rows="rows" :fields="fields" @selected="onUpdateManualTransaction" />
        <Pagination v-if="paginationData.totalPages > 1" :tableId="12" :paginationData="paginationData" :dropDownListItems="dropDownListItems" @tableObj="onPaginate" />
      </div>
    </vertical>
    <toast :showToast="showToast" :error="error" :title="toastMessage" />
  </div>
</template>

<script>
import dadbananWallet from '../../../services/dadban/wallet'
import vertical from '../../../layouts/vertical.vue'
import Table from '../../common/table/Table.vue'
import pageHeader from '../../layoutComponents/page-header.vue'
import TableHeader from '../../common/table/simpleTable/TableHeader.vue'
import Pagination from '../../common/table/simpleTable/Pagination.vue'
import Toast from '../../common/Toast.vue'

export default {
  components: { vertical, Table, pageHeader, TableHeader, Pagination, Toast },
  props: {},
  data() {
    return {
      showToast: false,
      error: false,
      toastMessage: '',
      headerItems: [
        {
          text: 'موجودی کیف پول کاربران',
          href: '/list/allbalancewithuserinfo',
        },
        {
          text: 'موجودی کیف پول کاربر',
          active: true,
        },
      ],
      fields: [],
      rows: [],
      userInformation: {},
      paginationData: {},
      fieldSearches: [],
      query: '',
      pageSize: 10,
      pageNumber: 1,
      dropDownListItems: [
        { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
        { id: 2, count: 20, value: 'نمایش 20 تایی', isDefault: false },
        { id: 3, count: 50, value: 'نمایش 50 تایی', isDefault: false },
      ],

      filterList: [
        { key: true, label: 'واریز', condition: 'IsIncrease' },
        { key: false, label: 'برداشت', condition: 'IsIncrease' },
        { key: 2, label: 'تراکنش موفق', condition: 'IsIncreaseStatus' },
        { key: 1, label: 'واریز موفق', condition: 'IsIncreaseStatus' },
        { key: 0, label: 'در انتظار واریز', condition: 'IsIncreaseStatus' },
      ],
    }
  },
  mounted() {
    this.initUserInformation()
    this.fetchUserTransactions()
  },
  watch: {
    '$route.query'(newQuery, oldQuery) {
      if (newQuery.userId !== oldQuery?.userId || newQuery.walletType !== oldQuery?.walletType) {
        this.initUserInformation()
      }
      this.fetchUserTransactions()
    },
  },
  methods: {
    initUserInformation() {
      const { userId, walletType, userName } = this.$route.query
      if (userId && walletType) {
        this.userInformation = { userId, walletType, userName: userName || '' }
        return
      }
      const stored = window.localStorage.getItem('walletUserInformation')
      if (stored) {
        this.userInformation = JSON.parse(stored)
      }
    },
    async onUpdateManualTransaction(payload) {
      try {
        const result = await dadbananWallet.updateManualPayment({ id: payload[0].id, manualPayment: '', file: '' })
        if (result.data.data) {
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
            this.error = false
            this.toastMessage = 'تغییرات با موفقیت ذخیره گردید.'
          })
        } else {
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
            this.error = true
            this.toastMessage = 'عملیات با خطا مواجه شد لطفا دوباره تلاش کنید.'
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onSearchQuery(key) {
      let pageNumber = this.pageNumber
      let pageSizes = this.pageSize
      this.query = key.query
      this.fieldSearches = key.filters.length
        ? [
            {
              fieldName: key.filters[0].condition,
              text: String(key.filters[0].key),
            },
          ]
        : []
      try {
        const req = await dadbananWallet.UserTransactions({
          pageSize: pageSizes,
          pageNumber: pageNumber,
          sortBy: '',
          isSortAsc: true,
          fieldSearchs: this.fieldSearches,
          userId: this.userInformation.userId,
          coin: this.userInformation.walletType,
          search: this.query,
        })

        this.rows = req.data.data.rows
        this.fields = req.data.data.fields
        this.paginationData = req.data.pagination
      } catch (error) {
        console.log(error)
      }
    },
    async onPaginate(page) {
      this.pageNumber = page.page
      this.pageSize = page.pageSize.count

      try {
        const req = await dadbananWallet.UserTransactions({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          search: this.query,
          sortBy: '',
          isSortAsc: true,
          fieldSearchs: this.fieldSearches,
          userId: this.userInformation.userId,
          coin: this.userInformation.walletType,
        })

        this.rows = req.data.data.rows
        this.fields = req.data.data.fields
        this.paginationData = req.data.pagination
      } catch (error) {
        console.log(error)
      }
    },
    async fetchUserTransactions() {
      try {
        const req = await dadbananWallet.UserTransactions({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          sortBy: '',
          isSortAsc: true,
          search: this.query,
          fieldSearchs: this.fieldSearches,
          userId: this.userInformation.userId,
          coin: this.userInformation.walletType,
        })

        this.rows = req.data.data.rows
        this.fields = req.data.data.fields
        this.paginationData = req.data.pagination
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
